export default "__VITE_ASSET__B95_gM0n__"